import { z } from "zod";
import type { SurveyData } from "./types";

export const initialFormData: SurveyData = {
	riskTolerance: "",
	investmentHorizon: "",
	expertise: "",
	stockTypes: [],
	otherInvestments: [],
	goal: [],
	portfolioSize: "",
	investorType: [],
	investmentDuration: "",
	tools: [],
	terms: null,
};

export const surveySchema = z.object({
	riskTolerance: z.string().min(1, "Risk tolerance is required"),
	investmentHorizon: z.string().min(1, "Investment horizon is required"),

	expertise: z.string().min(1, "Please select your expertise level"),

	stockTypes: z
		.array(z.string())
		.min(1, "Please select what stocks you invest in"),

	otherInvestments: z
		.array(z.string())
		.min(1, "Please select other investment types"),

	goal: z.array(z.string()).min(1, "Please select your investment reasons"),

	portfolioSize: z.string().min(1, "Portfolio size is required"),

	investorType: z
		.array(z.string())
		.min(1, "Please select how you see yourself"),

	investmentDuration: z.string().min(1, "Investment duration is required"),

	tools: z.array(z.string()).min(1, "Please select tools you use"),

	terms: z
		.string()
		.nullable()
		.refine((val) => val === "on", {
			message: "You must accept the terms and conditions",
		}),
});
